<template>
    <svg class="arrow-icon" width="100%" height="100%" viewBox="0 0 67 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xml:space="preserve"  style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;">
        <path d="M1.4,1.4L33.186,34.586L64.97,1.4" style="fill:none;fill-rule:nonzero;stroke:black;stroke-width:2.8px;"/>
    </svg>
</template>

<script>
export default {
    name: "ArrowIcon"
}
</script>
